var BaseMsgItem = require('./BaseMsgItem');
var $ = require('jQuery');
var template = require('../../template/msg/text-msg-item.html');
/*require('./../../style/msg/text-msg-item.less');*/
var dispatcher = require('./../../global/dispatcher');
var ActionType = require('./../../constant/ActionType');
var EmotionHandler = require('../../../lib/EmotionHandler');
var MsgStatus = require('./../../constant/MsgStatus');
var XssFilter = require('../../../lib/XssFilter');
var RichTextFormat = require('../../../lib/RichTextFormat');
var html2Text = require('../../utils/html2Text');
var utils = require('./../../global/utils');
const { isEmpty } = require('./../../global/utils');
var _isGroupUser = utils.isGroupUser;
var _jsonHandler = utils.jsonHandler;
var _isEmpty = utils.isEmpty;
var isShopModeUser = utils.isShopModeUser;
var config = require('./../../global/config');
var urlReg = /(http|ftp|https):\/\/[\w\-_]+(\.[\w\-_]+)+([\w\-\.,@?^=%&:/~\+#]*[\w\-\@?^=%&/~\+#])?[^(&nbsp;)]/ig;

var href_tpl = '<a class="im-msg-action im-msg-click" data-msg-id="${msg-id}">${content}</a>';
var _replaceUrlSrc = function (txt) {
  var result = txt.replace(urlReg, function (item) {
    return '<a class="im-msg-action" href="' + item + '" target="_blank">' + item + '</a>';
  });
  return result;
};
var _replaceText = function (originalText, rules) {
  if (_isEmpty(originalText) || _isEmpty(rules) || rules.length === 0) {
    return originalText;
  }
  var result = originalText;
  rules.sort(function (a, b) {
    return b.rule.pos_start - a.rule.pos_start
  })
  $.each(rules, function (key, value) {
    var rule = value.rule;
    var posStart = rule.pos_start;
    var posEnd = rule.pos_end;
    // var targetText = rule.name;
    var originalLen = originalText.length;
    // if (originalText.substring(posStart, posEnd) === targetText || posStart == posEnd) {
      result = result.substring(0, posStart) + value.replaceText + result.substring(posEnd, originalLen);
    // }
  })
  return result;
}
var _textToEmotion = function (content) {
  content = content.replace(/(\[[^\[\]]*\])/g, function (item) {
    var emotionID = EmotionHandler.emotionTitles.indexOf(item.replace(/[\[\]]/g, ''));
    //普通文本
    if (emotionID == -1) {
      return item;
    }
    return '<div style="margin-bottom:-3px;margin-left:5px;display:inline-block;" class="im-emotion-' + emotionID + '"></div>';
  });
  return content;
};
var _msgAtInfo = function (msg, type) {
  if (_isEmpty(msg) || _isEmpty(msg.content) || msg.content.type != 'text' || _isEmpty(msg.at_info) || msg.at_index === -1) {
    return msg;
  }
  var rules = [];
  var atInfo;
  if (typeof (msg.at_info) === 'string') {
    atInfo = _jsonHandler.parse(msg.at_info);
  }
  if (_isEmpty(atInfo)) {
    return msg;
  }
  var targetsArr = atInfo.targets;
  if (_isEmpty(targetsArr) || targetsArr.length == 0) {
    return msg;
  }
  var content = typeof (msg.content) === 'string' ? _jsonHandler.parse(msg.content) : !_isEmpty(msg.content) ? msg.content : {};
  // at_info字端
  var in_group = _isGroupUser({ user_source: msg.to_source });
  switch (type) {
    case 'session':
      break;
    default:
      $.each(targetsArr, function (key, item) {
        var txt;
        if (in_group) {
          if (_isGroupUser({ user_source: item.source })) {
            if (!msg.extendAt && (content.msg).indexOf('@所有人') == -1) {
              txt = '@所有人 ';
            }
          }
        } else {
          if (!msg.is_mine) {
            let  me = config['me']();
            let meKey = me.user_id + '@' + me.user_source;
            if (meKey === item.id + '@' + item.source && me.userInfo && me.userInfo.user_name) {
              txt = '@' + me.userInfo.user_name;
            }
          }
        }
        if (!_isEmpty(txt)) {
          rules.push({
            rule: item,
            replaceText: txt
          })
        }
      })
      content.msg = _replaceText(content.msg, rules);
      break;
  }
  msg.content = typeof (msg.content) === 'string' ? _jsonHandler.stringify(content) : content;
  return msg;
};
var _textFormat = function (content) {
  //换行处理
  content = content.replace(/(\n)/g, '<br>');
  //文本多个空格替换
  content = content.replace(/\s/g, '&nbsp;');
  //链接转换
  content = _replaceUrlSrc(content);
  //表情转换
  content = _textToEmotion(content);
  // xssFilter,将'<'替换成’&lt;将'>'替换成&gt;
  content = XssFilter.doFilter(content);
  return content;
};

var TextMsgItem = function (options) {
  (function (self) {
    var defaults = {
      template: template
    };
    $.extend(defaults, options);
    BaseMsgItem.call(self, defaults);
  })(this);

  // 是否已经被render过
  this._rendered = false;
};
TextMsgItem.prototype = Object.create(BaseMsgItem.prototype);
TextMsgItem.prototype.renderContent = function () {
  var msg = this._data.msg;
  msg = _msgAtInfo(msg);
  var msgcontent = msg.content;
  var content;
  var extra = !_isEmpty(msgcontent.extra) && typeof msgcontent.extra == 'string' ? _jsonHandler.parse(msgcontent.extra) : {};
  var imExtra = !_isEmpty(msgcontent.imExtra) ? msgcontent.imExtra : {};
  // 是否需要进行富文本转换
  if (!_isEmpty(extra) && !_isEmpty(extra.better_msg)) {
    if (extra.better_msg.type == 'shop_common_card') {
      var elements = extra.better_msg.element || [];
      elements.forEach(function (element) {
        if (element.type == "text") {
          msgcontent.msg = element.text;
        } else if (element.type == "buttons") {
          (element.childs || []).forEach(function (child) {
            if (child.type == 'button' && child.action && child.actionData && child.actionPostData) {
              if (child.text != '恢复绑定') return;
              if (_isEmpty(msgcontent.actions)) msgcontent.actions = [];
              msgcontent.actions.push({
                action: child.action,
                actionData: child.actionData,
                actionPostData: (!_isEmpty(child.actionPostData)) ? _jsonHandler.parse(child.actionPostData) : {},
                actionText: child.text
              });
            }
          });
        }
      });
    }
  }
  if (!RichTextFormat.isNeedConvert(msgcontent)) {
    var contentOriginal = msgcontent.msg || '';
    var contentTemp = msgcontent.msg || '';
    var urlRow = [];
    var contentRow = [];
    var urlContent;
    var urlPlus = '';
    contentOriginal = contentOriginal.replace(urlReg, function(item){
      if (!isEmpty(item)) {
        urlContent = {
          value: item,
          length: item.length,
          start: contentTemp.indexOf(item) + urlPlus.length
        };
        urlContent.end = urlContent.start + item.length;
        if (urlRow.length) {
          if (urlContent.start == urlRow[urlRow.length - 1].end) {
            urlContent.position = urlRow[urlRow.length - 1].position + 1;
          } else if (urlContent.start > urlRow[urlRow.length - 1].end) {
            urlContent.position = urlRow[urlRow.length - 1].position + 2;
          }
          contentRow.push(msgcontent.msg.slice(urlRow[urlRow.length - 1].end, urlContent.start));
        } else {
          urlContent.position = urlContent.start > 0 ? 1 : 0;
          contentRow.push(msgcontent.msg.slice(0, urlContent.start));
        }
        urlRow.push(urlContent);
        contentTemp = contentTemp.replace(item, '');
        urlPlus += item;
      }
      return '';
    });
    if (urlRow.length) {
      if (urlRow[urlRow.length - 1].end < msgcontent.msg.length - 1) {
        contentRow.push(msgcontent.msg.slice(urlRow[urlRow.length - 1].end));
      }
      contentOriginal = contentRow.map(function(text){
        return html2Text(text);
      });
      urlRow.forEach(function(urlInfo){
        contentOriginal.splice(urlInfo.position, 0, urlInfo.value);
      });
      content = _textFormat(contentOriginal.join(''));
    } else {
      content = _textFormat(html2Text(msgcontent.msg));
    }
  } else {
    msgcontent.extra = extra;
    var richtext = msgcontent.extra.richtext_format.richtext;
    msgcontent.extra.richtext_format.richtext = _textFormat(richtext);
    // 富文本转换
    msgcontent.extra = _jsonHandler.stringify(msgcontent.extra);
    msg.content = msgcontent;
    content = RichTextFormat.richTextFormat(msg).content.msg;
  }

  if (!_isEmpty(msgcontent.actions)) {
    var _content = content + '<br/>';
    if (!_isEmpty(msgcontent.actions) && msgcontent.actions.length) {
      msgcontent.actions.forEach(function (action) {
        _content += href_tpl.replace('${content}', action.actionText).replace('${msg-id}', msg.msg_id);
      });
    }
    this._element.find('.im-msg-content').html(_content);
  } else {
    this._element.find('.im-msg-content').html(content);
    if (!_isEmpty(this._options.me) && isShopModeUser(msg, this._options.me) && !imExtra.isAIMsg && !msg.is_mine && _isEmpty(msgcontent.quote)) {
      var meIdSource = this._options.me.user_id + '@' + this._options.me.user_source;
      if (meIdSource != msg.sender_id + '@' + msg.sender_source && meIdSource != msg.to_id + '@' + msg.to_source) {
        this._element.find('.im-msg-ai').data('msg-id', msg.msg_id).show();
      }
    }
  }
  var $content = this._element.find('.im-msg-content');
  $content.click(function (e) {
    e.stopPropagation();
    if(msg.msg_showtype ==="collect"){
      dispatcher.dispatch({
        type: ActionType.COLLECTION_MESSAGE_FLOAT,
        data: {
          msgList: msg.msgs,
          title: msg.sender_info.user_name+'聊天记录',
          id: msg.msg_id,
          parent_u_key:msg.content._parent_u_key ?msg.content._parent_u_key:''
        }
      });
    }
    
  });
};

module.exports = TextMsgItem;
